/* global theme */
/*
 * Promo 2 — Brinde Roland Garros por QUANTIDADE de items da coleção.
 *
 * Funciona independente da Promo 1 (cart-free-gift.js) — usam properties distintas:
 *   - Promo 1: _free_gift=true (garrafa por valor mínimo)
 *   - Promo 2: _free_gift_rg=true (chaveiro por contagem de items RG)
 *
 * Ambas rodam SIMULTANEAMENTE no mesmo cart drawer sem conflito.
 *
 * Requer no Admin Shopify um desconto automático "Buy X get Y":
 *   - Compra: ≥N items da coleção Roland Garros
 *   - Ganha: o variant_id configurado, a 100% off
 */
(function () {
  const GIFT_PROPERTY_KEY = '_free_gift_rg';
  const GIFT_PROPERTY_KEY_OTHER = '_free_gift'; // Promo 1 — não mexer
  let discountValidationFailed = false;

  function findGiftCard() {
    return document.querySelector('[data-cart-free-gift-rg]');
  }

  function getCart() {
    return fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' }
    }).then((r) => r.json());
  }

  function findGiftLine(cart) {
    return cart.items.find(
      (item) =>
        item.properties &&
        String(item.properties[GIFT_PROPERTY_KEY]) === 'true'
    );
  }

  /**
   * Verifica se cart QUALIFICA para a garrafa (Promo 1) — subtotal (sem brindes)
   * >= o min_amount configurado no card da Promo 1.
   *
   * Why: prioridade INVERTIDA — quando garrafa qualifica, chaveiro yield.
   * Motivo operacional: expedição reclamou de faturar dois SKUs de brinde no
   * mesmo pedido. Garrafa sai mais e tem fluxo logístico simples, então virou
   * a prioritária. Ajuste temporário pedido pelo Danilo (2026-05-26).
   *
   * @param {Object} cart - response do /cart.js
   * @returns {boolean}
   */
  function cartQualifiesForGarrafa(cart) {
    const garrafaCard = document.querySelector('[data-cart-free-gift]');
    if (!garrafaCard) return false;
    const minAmount = parseInt(garrafaCard.dataset.giftMinAmount, 10);
    if (!minAmount || isNaN(minAmount)) return false;

    // Subtotal sem brindes (igual lógica da Promo 1)
    let subtotalExclGifts = cart.total_price;
    for (const item of cart.items) {
      if (isAnyGiftLine(item)) {
        subtotalExclGifts -= item.final_line_price;
      }
    }
    return subtotalExclGifts >= minAmount;
  }

  function isAnyGiftLine(item) {
    if (!item.properties) return false;
    return (
      String(item.properties[GIFT_PROPERTY_KEY]) === 'true' ||
      String(item.properties[GIFT_PROPERTY_KEY_OTHER]) === 'true'
    );
  }

  function dispatchCartChange() {
    document.dispatchEvent(
      new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
    );
  }

  /**
   * Conta items do cart que pertencem à coleção alvo, excluindo brindes.
   * @param {Object} cart - cart.js response
   * @param {Set<number>} productIdsInCollection
   * @returns {number}
   */
  function countQtyInCollection(cart, productIdsInCollection) {
    if (!productIdsInCollection || productIdsInCollection.size === 0) return 0;
    let count = 0;
    for (const item of cart.items) {
      if (isAnyGiftLine(item)) continue;
      if (productIdsInCollection.has(Number(item.product_id))) {
        count += item.quantity;
      }
    }
    return count;
  }


  async function addGift(variantId) {
    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: { [GIFT_PROPERTY_KEY]: 'true' }
          }
        ]
      })
    });
    if (!res.ok) return false;

    // Validação: desconto Shopify precisa ter zerado o preço
    const cart = await getCart();
    const giftLine = findGiftLine(cart);
    if (giftLine && giftLine.final_line_price > 0) {
      await removeGift(giftLine.key);
      discountValidationFailed = true;
      // eslint-disable-next-line no-console
      console.error(
        '[cart-free-gift-rg] Brinde Roland Garros removido: o desconto automático NÃO aplicou ' +
          '(linha ficou com R$ ' +
          (giftLine.final_line_price / 100).toFixed(2) +
          '). Verifique no Admin → Discounts → "Compre 2 RG, ganhe chaveiro" se está ATIVO ' +
          'e aponta para o variant_id correto a 100% off.'
      );
      return false;
    }
    return true;
  }

  function removeGift(lineKey) {
    return fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
  }

  async function enforceGiftQuantity(cart) {
    const giftLine = findGiftLine(cart);
    if (giftLine && giftLine.quantity !== 1) {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 1 })
      });
      return true;
    }
    return false;
  }

  /**
   * Sincroniza estado do brinde com base no cart atual.
   * - Adiciona se atingiu min_qty e ainda não está no cart
   * - Remove se caiu abaixo de min_qty e está no cart
   * - Remove se está no cart mas o desconto Shopify foi suprimido
   *   (acontece quando Promo 1 e Promo 2 ambas qualificam e os discounts
   *    não estão configurados como combinable no Admin)
   */
  async function sync() {
    if (discountValidationFailed) return; // não tentar de novo na mesma sessão

    const card = findGiftCard();
    if (!card) return;

    const variantId = card.dataset.giftVariantId;
    const minQty = parseInt(card.dataset.giftMinQty, 10) || 2;
    const productIdsRaw = (card.dataset.giftProductIds || '').trim();
    if (!variantId || !productIdsRaw) return;

    const productIds = new Set(
      productIdsRaw
        .split(',')
        .map((s) => parseInt(s.trim(), 10))
        .filter((n) => !isNaN(n) && n > 0)
    );

    const cart = await getCart();
    const giftLine = findGiftLine(cart);
    const qtyInCollection = countQtyInCollection(cart, productIds);

    // Regra de qualificação do chaveiro: ≥ minQty items RG no cart.
    // PRIORIDADE: garrafa vence. Se cart qualifica para garrafa (subtotal >= min_amount
    // da Promo 1), chaveiro yield — fica fora do cart, mesmo com ≥2 itens RG.
    // Motivo operacional: expedição não quer faturar dois SKUs de brinde no mesmo
    // pedido; garrafa sai mais. Ajuste temporário (2026-05-26).
    const qualifies = qtyInCollection >= minQty && !cartQualifiesForGarrafa(cart);

    if (qualifies && !giftLine) {
      const ok = await addGift(variantId);
      if (ok) dispatchCartChange();
    } else if (!qualifies && giftLine) {
      // Caiu fora da regra: qty < minQty OU cart agora qualifica para garrafa
      await removeGift(giftLine.key);
      dispatchCartChange();
    } else if (giftLine) {
      // Brinde já no cart — re-validar que o desconto continua aplicado.
      // Com mútua exclusividade JS-side a Promo 1 não entra junto, então este
      // ramo só vê chaveiro suprimido se algum app/manipulação externa zerou o
      // desconto. Removemos sem travar — se o estado normalizar, addGift refaz.
      if (giftLine.final_line_price > 0) {
        // eslint-disable-next-line no-console
        console.warn(
          '[cart-free-gift-rg] Desconto Promo 2 suprimido (chaveiro a R$ ' +
            (giftLine.final_line_price / 100).toFixed(2) +
            '). Verifique no Admin → Discounts se "Compre 2 RG, ganhe chaveiro" ' +
            'está ATIVO e aponta para variant_id 52201582297399 a 100% off.'
        );
        await removeGift(giftLine.key);
        dispatchCartChange();
        return;
      }
      if (giftLine.quantity !== 1) {
        const fixed = await enforceGiftQuantity(cart);
        if (fixed) dispatchCartChange();
      }
    }
  }

  // Listeners
  function init() {
    // Sync inicial
    sync();

    // Re-sync sempre que o cart muda
    document.addEventListener('on:cart:after-merge', () => sync());
    document.addEventListener('on:cart:change', () => {
      // Debounce pra não disparar em loop
      if (window.__rgGiftSyncTimer) clearTimeout(window.__rgGiftSyncTimer);
      window.__rgGiftSyncTimer = setTimeout(sync, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
